var map = {
	"./ar/first_semester/Unit_1/12.png": 8232,
	"./ar/first_semester/Unit_1/20.jpeg": 8556,
	"./ar/first_semester/Unit_3/131 (1).jpeg": 3797,
	"./ar/first_semester/Unit_3/131 (2).jpeg": 4170,
	"./ar/first_semester/Unit_3/133.jpeg": 4217,
	"./ar/first_semester/Unit_4/153.jpeg": 1746,
	"./ar/first_semester/Unit_4/179.jpeg": 2690,
	"./ar/second_semester/Unit_5/17.jpeg": 6090,
	"./ar/second_semester/Unit_5/23.jpeg": 6845,
	"./ar/second_semester/Unit_5/26.jpeg": 3042,
	"./ar/second_semester/Unit_6/56.jpeg": 4258,
	"./ar/second_semester/Unit_6/57 (1).jpeg": 4351,
	"./ar/second_semester/Unit_6/57 (2).jpeg": 4560,
	"./ar/second_semester/Unit_6/58 (1).jpeg": 9550,
	"./ar/second_semester/Unit_6/58 (2).jpeg": 1929,
	"./ar/second_semester/Unit_6/59 (1).jpeg": 5121,
	"./ar/second_semester/Unit_6/60 (1).jpeg": 4910,
	"./ar/second_semester/Unit_6/60 (2).jpeg": 2422,
	"./ar/second_semester/Unit_6/60 (3).jpeg": 9507,
	"./ar/second_semester/Unit_6/60 (4).jpeg": 5352,
	"./ar/second_semester/Unit_6/61 (1).jpeg": 910,
	"./ar/second_semester/Unit_6/61 (2).jpeg": 3673,
	"./ar/second_semester/Unit_6/62.jpeg": 9861,
	"./ar/second_semester/Unit_6/63 (1).jpeg": 5176,
	"./ar/second_semester/Unit_6/63 (2).jpeg": 6679,
	"./ar/second_semester/Unit_6/64 (1).jpeg": 3613,
	"./ar/second_semester/Unit_6/65 (1).jpeg": 6794,
	"./ar/second_semester/Unit_6/65 (2).jpeg": 6981,
	"./ar/second_semester/Unit_6/66.jpeg": 6497,
	"./ar/second_semester/Unit_6/68 (1).jpeg": 5689,
	"./ar/second_semester/Unit_6/68 (2).jpeg": 9710,
	"./ar/second_semester/Unit_6/70 (1).jpeg": 804,
	"./ar/second_semester/Unit_6/70 (2).jpeg": 9331,
	"./ar/second_semester/Unit_8/109 (1).jpeg": 1591,
	"./ar/second_semester/Unit_8/109 (2).jpeg": 7512,
	"./ar/second_semester/Unit_8/111.jpeg": 9036,
	"./ar/second_semester/Unit_8/112 (1).jpeg": 8275,
	"./ar/second_semester/Unit_8/112 (2).jpeg": 9748,
	"./ar/second_semester/Unit_8/112 (3).jpeg": 913,
	"./ar/second_semester/Unit_8/115.jpeg": 1496,
	"./ar/second_semester/Unit_8/122.jpeg": 4366,
	"./ar/second_semester/Unit_9/168.jpeg": 2443,
	"./en/Basic example/bar3.jpg": 2015,
	"./en/Basic example/box3.png": 7619,
	"./en/Basic example/multi3.png": 4588,
	"./en/Basic example/tree1.png": 1752,
	"./ja/poc_6/17.jpeg": 1145,
	"./ja/poc_6/23.jpeg": 8942,
	"./ja/poc_6/24.jpeg": 599,
	"./ja/poc_6/26.jpeg": 7537,
	"./ja/poc_7/231_1.png": 2165,
	"./ja/poc_7/231_2.png": 5438,
	"./ja/poc_7/231_3.png": 1223,
	"./ja/poc_7/231_4.png": 1608,
	"./ja/poc_7/238.png": 2764,
	"./ja/poc_7/239_a.png": 6749,
	"./ja/poc_7/239_b.png": 5510,
	"./ja/poc_7/240.png": 3437,
	"./ja/poc_7/243.png": 2758,
	"./ja/poc_7/244.png": 7017,
	"./ja/poc_7/245.png": 2192,
	"./ja/poc_7/247.png": 1874,
	"./ja/poc_7/248.png": 3877,
	"./ja/poc_7/249.png": 988,
	"./ja/poc_7/251.png": 3803,
	"./ja/poc_7/253.png": 8761,
	"./ja/poc_7/254.png": 9366,
	"./ja/poc_7/255.png": 8383,
	"./ko/Basic example/bar.png": 2917,
	"./ko/Basic example/box1.png": 5800,
	"./ko/Basic example/mix.png": 1992,
	"./ko/Basic example/multi2.png": 1883,
	"./ko/Basic example/tree2.png": 5676,
	"./ko/Basic example/violin1.png": 9562,
	"./ko/Basic example2/bar2.png": 4709,
	"./ko/Basic example2/bar3.jpg": 3624,
	"./ko/Basic example2/box3.png": 6860,
	"./ko/Basic example2/image.png": 2139,
	"./ko/Basic example2/line2.png": 3904,
	"./ko/Basic example2/line3.png": 8105,
	"./ko/Basic example2/multi3.png": 3876,
	"./ko/Basic example2/pie1.png": 7469,
	"./ko/Basic example2/pie2.png": 6262,
	"./ko/Basic example2/tree1.png": 5,
	"./ko/Basic example2/violin2.png": 5963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1716;